import type { Recall } from "../shared/types";

const WEEK_MS = 7 * 24 * 60 * 60 * 1_000;
const MAX_CAPTIONS = 14;
const MAX_CAPTION_LENGTH = 72;

function titleProduct(title: string): string {
  return title
    .replace(/^.+?\brecalls?\b\s*/i, "")
    .replace(/\s+(?:because of|due to|for)\s+.+$/i, "")
    .trim();
}

export function recallCaption(recall: Recall): string {
  const candidate = recall.productDescription || titleProduct(recall.title) || recall.company || recall.title;
  const firstItem = candidate.split(/[;\n]/, 1)[0]?.replace(/\s+/g, " ").trim() || "RECALLED FOOD";
  const clipped = firstItem.length > MAX_CAPTION_LENGTH
    ? `${firstItem.slice(0, MAX_CAPTION_LENGTH - 1).trimEnd()}…`
    : firstItem;
  return `${clipped} — RECALLED`;
}

export function recentRecallCaptions(recalls: Recall[], now = new Date()): string[] {
  const threshold = now.getTime() - WEEK_MS;
  const captions: string[] = [];
  const seen = new Set<string>();

  for (const recall of recalls) {
    const publishedAt = Date.parse(recall.publishedAt);
    if (!Number.isFinite(publishedAt) || publishedAt < threshold || publishedAt > now.getTime()) continue;
    const caption = recallCaption(recall);
    const key = caption.toLocaleLowerCase("en-US");
    if (seen.has(key)) continue;
    seen.add(key);
    captions.push(caption);
    if (captions.length === MAX_CAPTIONS) break;
  }

  return captions.length > 0 ? captions : ["NO NEW FOOD RECALLS THIS WEEK"];
}
